import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { fetchLostProjects } from '../redux/LostReducer';
import { Link, useNavigate } from 'react-router-dom';

function LostProject() {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.lostProjects); // Fetch state from Redux
console.log("LostProject data:", data);

  const userUID = localStorage.getItem('userUID');
  console.log("userUID:", userUID);
    const navigation = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [lim, setLim] = useState(10);

  useEffect(() => {
    if (userUID) {
      dispatch(fetchLostProjects( {userUID} ));
    }
  }, [dispatch, userUID]);

  return (
    <Container fluid>
      <Row className="m-0">
        <Col sm={1}></Col>
        <Col sm={11}>
          <Row className="mt-5">
            <Col>
              <Row className="headingPart">
                <Col sm={2}>
                  <h4>Lost Projects</h4>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col sm={12}>
                  <div className="table-container">
                    {status === "loading" ? (
                      <div className="loader">Loading...</div>
                    ) : status === "failed" ? (
                      <p className="text-danger">{error}</p>
                    ) : status === "succeeded" && data.clients.length > 0 ? (
                      <div className="tableScroll">
                        <table>
                          <thead>
                            <tr>
                              <th>Project</th>
                              <th>Name</th>
                              <th>Number</th>
                              <th>Create</th>
                              <th>Status</th>
                              <th>Created By</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.clients.map((project) => (
                              <tr key={project.id}>
                                <td>{project.pname}</td>
                                <td>{project.cname}</td>
                                <td>{project.cphone}</td>
                                <td>{project.date}</td>
                                <td>{project.status}</td>
                                <td>{project.createdBy}</td>
                                <td>
                                
                                    <button  onClick={() => {
                              navigation('/lost/lostprojectRoom', { state: project });
                            }} className="buttonDesign">View Rooms</button>
                               
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="noDataFound">No lost projects found.</div>
                    )}
                  </div>
                </Col>
              </Row>

            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default LostProject;
